/**
 * Combo upsell — tiroir panier JGQ
 * Affiche l'offre apres ajout d'un jeu gonflable.
 */
(function () {
  'use strict';

  var STORAGE_KEY = 'jgq-combo-drawer-dismissed';
  var CFG = window.JGQ_COMBO_DRAWER_CFG || {
    machineHandle: 'machine-a-barbe-a-papa',
    sucreHandle: 'sucre-barbe-a-papa',
    conesHandle: 'cones-a-barbe-a-papa',
    sucreQty: 2,
    conesQty: 25,
    badge: 'Offre spéciale −10 %',
    heading: 'Combo fête : barbe à papa −10 %',
    subheading: 'Ajoutez la machine, 25 cônes et 2 sacs de sucre à votre jeu.',
    addLabel: 'Ajouter le combo',
    skipLabel: 'Non merci',
    addUrl: '/cart/add.js'
  };

  var products = { machine: null, sucre: null, cones: null };
  var busy = false;
  var stylesReady = false;

  function log() {
    if (typeof console !== 'undefined' && console.info) {
      console.info.apply(console, ['[JGQ Combo Drawer]'].concat([].slice.call(arguments)));
    }
  }

  function ensureStyles() {
    if (stylesReady || document.getElementById('jgq-combo-drawer-css')) {
      stylesReady = true;
      return;
    }
    var style = document.createElement('style');
    style.id = 'jgq-combo-drawer-css';
    style.textContent = [
      '#jgq-combo-drawer{display:none;margin:0 0 14px;padding:14px;border-radius:14px;border:1px solid #b8dfea;background:#e8f6fb;font-family:"Baloo 2",sans-serif}',
      '#jgq-combo-drawer.is-visible{display:block!important}',
      '#jgq-combo-drawer .jcd-badge{display:inline-flex;padding:4px 10px;margin-bottom:8px;font-size:11px;font-weight:800;letter-spacing:.03em;text-transform:uppercase;color:#1a1a2e;background:#fdd835;border-radius:999px}',
      '#jgq-combo-drawer .jcd-title{margin:0 0 6px;font-size:16px;font-weight:800;color:#1a1a2e;line-height:1.25}',
      '#jgq-combo-drawer .jcd-sub{margin:0 0 10px;font-size:13px;font-weight:500;color:#157a9e;line-height:1.4}',
      '#jgq-combo-drawer .jcd-items{list-style:none;margin:0 0 10px;padding:0}',
      '#jgq-combo-drawer .jcd-items li{display:flex;justify-content:space-between;gap:8px;font-size:13px;font-weight:600;color:#333;padding:4px 0}',
      '#jgq-combo-drawer .jcd-total{display:flex;justify-content:space-between;gap:8px;margin-bottom:6px;font-size:14px;font-weight:800;color:#1985b4}',
      '#jgq-combo-drawer .jcd-note{margin:0 0 12px;font-size:11px;color:#666;line-height:1.35}',
      '#jgq-combo-drawer .jcd-actions{display:flex;flex-wrap:wrap;gap:8px}',
      '#jgq-combo-drawer .jcd-btn-add{flex:1;min-width:140px;padding:10px 14px;border:none;border-radius:999px;background:#1985b4;color:#fff;font-family:inherit;font-size:14px;font-weight:800;cursor:pointer}',
      '#jgq-combo-drawer .jcd-btn-add:disabled{opacity:.55;cursor:not-allowed}',
      '#jgq-combo-drawer .jcd-btn-skip{flex:1;min-width:100px;padding:10px 14px;border:2px solid #cfe8f1;border-radius:999px;background:#fff;color:#555;font-family:inherit;font-size:14px;font-weight:700;cursor:pointer}',
      '#jgq-combo-drawer .jcd-error{display:none;margin-top:8px;font-size:12px;font-weight:700;color:#c0392b}',
      '#jgq-combo-drawer .jcd-error.is-visible{display:block}',
      /* Toujours visible même si le footer avait is-empty */
      '.drawer__footer #jgq-combo-drawer.is-visible{display:block!important}'
    ].join('');
    document.head.appendChild(style);
    stylesReady = true;
  }

  function ensureDom() {
    ensureStyles();
    var el = document.getElementById('jgq-combo-drawer');
    if (el) return el;

    var host =
      document.querySelector('.drawer__footer .cart-drawer__footer') ||
      document.querySelector('.drawer__footer') ||
      document.querySelector('#CartDrawer .drawer__inner') ||
      document.getElementById('CartDrawer');

    if (!host) {
      log('pas de host drawer encore');
      return null;
    }

    el = document.createElement('div');
    el.id = 'jgq-combo-drawer';
    el.hidden = true;
    el.innerHTML =
      '<span class="jcd-badge"></span>' +
      '<p class="jcd-title"></p>' +
      '<p class="jcd-sub"></p>' +
      '<ul class="jcd-items"></ul>' +
      '<div class="jcd-total"><span>Total combo estimé (−10 %)</span><span class="jcd-total-value">—</span></div>' +
      '<p class="jcd-note">Le rabais de 10 % s’applique à la caisse. Votre jeu déjà choisi n’est pas ajouté une 2e fois.</p>' +
      '<div class="jcd-actions">' +
      '<button type="button" class="jcd-btn-add"></button>' +
      '<button type="button" class="jcd-btn-skip"></button>' +
      '</div>' +
      '<p class="jcd-error" role="alert"></p>';

    el.querySelector('.jcd-badge').textContent = CFG.badge;
    el.querySelector('.jcd-title').textContent = CFG.heading;
    el.querySelector('.jcd-sub').textContent = CFG.subheading;
    el.querySelector('.jcd-btn-add').textContent = CFG.addLabel;
    el.querySelector('.jcd-btn-skip').textContent = CFG.skipLabel;

    if (host.classList.contains('cart-drawer__footer')) {
      host.parentNode.insertBefore(el, host);
    } else if (host.classList.contains('drawer__footer')) {
      host.insertBefore(el, host.firstChild);
    } else {
      host.appendChild(el);
    }

    bind(el);
    log('DOM injecté');
    return el;
  }

  function formatMoney(cents) {
    try {
      if (window.Shopify && typeof Shopify.formatMoney === 'function') {
        return Shopify.formatMoney(cents);
      }
    } catch (e) {}
    return (Number(cents) / 100).toFixed(2).replace('.', ',') + ' $';
  }

  function itemBlob(item) {
    return (' ' + [
      item.product_title || '',
      item.title || '',
      item.variant_title || '',
      item.product_type || '',
      item.handle || '',
      item.url || ''
    ].join(' ') + ' ').toLowerCase();
  }

  function isCottonMachine(item) {
    var t = itemBlob(item);
    var h = (item.handle || '').toLowerCase();
    if (h.indexOf('machine-a-barbe') !== -1) return true;
    if (products.machine && Number(item.variant_id || item.id) === Number(products.machine.variantId)) return true;
    return (t.indexOf('barbe à papa') !== -1 || t.indexOf('barbe a papa') !== -1) && t.indexOf('machine') !== -1;
  }

  function isInflatable(item) {
    if (isCottonMachine(item)) return false;
    var t = itemBlob(item);
    var skip = [
      'cônes à barbe', 'cones a barbe', 'sucre à', 'sucre a', 'sachet',
      'consommable', 'hot-dog', 'hot dog', 'popcorn', 'slush',
      'à vendre', 'a vendre', 'rallonge', 'tapis de', 'jukebox',
      'génératrice', 'generatrice', 'canon à mousse'
    ];
    for (var i = 0; i < skip.length; i++) {
      if (t.indexOf(skip[i]) !== -1) return false;
    }
    if (
      t.indexOf('résidentiel') !== -1 ||
      t.indexOf('residentiel') !== -1 ||
      t.indexOf('commercial') !== -1 ||
      /\b\d+\s*jour/.test(t)
    ) return true;
    var pos = [
      'gonflable', 'chateau', 'château', 'glissade', 'parcours', 'toboggan',
      'bouncer', 'castle', 'splash', 'piscine', 'aquatique', 'obstacle',
      'combo', 'caserne', 'bootcamp', 'interactif', 'joute', 'roi lion',
      'licorne', 'mickey', 'barbie', 'batman', 'spiderman'
    ];
    for (var j = 0; j < pos.length; j++) {
      if (t.indexOf(pos[j]) !== -1) return true;
    }
    return false;
  }

  function cartEligible(cart) {
    if (!cart || !cart.items || !cart.items.length) return false;
    var hasGame = false;
    var hasMachine = false;
    cart.items.forEach(function (item) {
      if (isCottonMachine(item)) hasMachine = true;
      if (isInflatable(item)) hasGame = true;
    });
    return hasGame && !hasMachine;
  }

  function fetchProduct(handle) {
    return fetch('/products/' + encodeURIComponent(handle) + '.js')
      .then(function (r) {
        if (!r.ok) throw new Error('404 ' + handle);
        return r.json();
      })
      .then(function (p) {
        var v = null;
        var variants = p.variants || [];
        for (var i = 0; i < variants.length; i++) {
          if (variants[i].available) {
            v = variants[i];
            break;
          }
        }
        if (!v) v = variants[0];
        if (!v) throw new Error('no variant ' + handle);
        return { title: p.title, variantId: v.id, price: v.price, handle: p.handle };
      });
  }

  function loadProducts() {
    if (products.machine && products.cones && products.sucre) {
      return Promise.resolve(products);
    }
    return Promise.all([
      fetchProduct(CFG.machineHandle),
      fetchProduct(CFG.conesHandle),
      fetchProduct(CFG.sucreHandle)
    ]).then(function (list) {
      products.machine = list[0];
      products.cones = list[1];
      products.sucre = list[2];
      log('produits OK', products.machine.title);
      return products;
    });
  }

  function renderDetails(el) {
    var list = el.querySelector('.jcd-items');
    var totalEl = el.querySelector('.jcd-total-value') || el.querySelector('#jgq-combo-drawer-total');
    if (!list) return;

    if (!products.machine) {
      list.innerHTML =
        '<li><span>1 × Machine à barbe à papa</span><span>—</span></li>' +
        '<li><span>' + CFG.conesQty + ' × Cônes</span><span>—</span></li>' +
        '<li><span>' + CFG.sucreQty + ' × Sacs de sucre</span><span>—</span></li>';
      if (totalEl) totalEl.textContent = '−10 % à la caisse';
      return;
    }

    var cq = Number(CFG.conesQty || 25);
    var sq = Number(CFG.sucreQty || 2);
    var sub =
      Number(products.machine.price) +
      Number(products.cones.price) * cq +
      Number(products.sucre.price) * sq;
    var total = sub - Math.round(sub / 10);
    list.innerHTML =
      '<li><span>1 × ' + products.machine.title + '</span><span>' + formatMoney(products.machine.price) + '</span></li>' +
      '<li><span>' + cq + ' × ' + products.cones.title + '</span><span>' + formatMoney(Number(products.cones.price) * cq) + '</span></li>' +
      '<li><span>' + sq + ' × ' + products.sucre.title + '</span><span>' + formatMoney(Number(products.sucre.price) * sq) + '</span></li>';
    if (totalEl) totalEl.textContent = formatMoney(total);
  }

  function revealFooter() {
    var footer = document.querySelector('.drawer__footer');
    if (footer) footer.classList.remove('is-empty');
    var drawer = document.querySelector('cart-drawer');
    if (drawer) drawer.classList.remove('is-empty');
    var items = document.querySelector('cart-drawer-items');
    if (items) items.classList.remove('is-empty');
  }

  function showOffer(el) {
    revealFooter();
    el.classList.add('is-visible');
    el.removeAttribute('hidden');
    log('offre visible');
  }

  function hideOffer(el) {
    el = el || document.getElementById('jgq-combo-drawer');
    if (!el) return;
    el.classList.remove('is-visible');
    el.setAttribute('hidden', '');
  }

  function showError(el, msg) {
    var err = el.querySelector('.jcd-error');
    if (!err) return;
    err.textContent = msg || '';
    err.classList.toggle('is-visible', !!msg);
  }

  function addCombo() {
    var el = document.getElementById('jgq-combo-drawer');
    if (!el || busy) return;

    var run = function () {
      if (!products.machine) {
        showError(el, 'Produits combo introuvables.');
        return;
      }
      busy = true;
      var btn = el.querySelector('.jcd-btn-add');
      if (btn) {
        btn.disabled = true;
        btn.textContent = 'Ajout…';
      }
      showError(el, '');

      fetch(CFG.addUrl || '/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({
          items: [
            { id: products.machine.variantId, quantity: 1, properties: { _combo_upsell: 'fete-barbe-a-papa' } },
            { id: products.cones.variantId, quantity: Number(CFG.conesQty || 25), properties: { _combo_upsell: 'fete-barbe-a-papa' } },
            { id: products.sucre.variantId, quantity: Number(CFG.sucreQty || 2), properties: { _combo_upsell: 'fete-barbe-a-papa' } }
          ],
          sections: ['cart-drawer', 'cart-icon-bubble']
        })
      })
        .then(function (r) {
          return r.json().then(function (data) {
            if (!r.ok) throw data;
            return data;
          });
        })
        .then(function (data) {
          try {
            sessionStorage.setItem(STORAGE_KEY, '1');
          } catch (e) {}
          busy = false;
          hideOffer(el);
          var drawer = document.querySelector('cart-drawer');
          if (drawer && data.sections && data.sections['cart-drawer'] && typeof drawer.renderContents === 'function') {
            try {
              drawer.renderContents({ id: products.machine.variantId, sections: data.sections });
            } catch (e) {}
          }
          setTimeout(refresh, 300);
        })
        .catch(function (err) {
          busy = false;
          log('add failed', err);
          btn = el.querySelector('.jcd-btn-add');
          if (btn) {
            btn.disabled = false;
            btn.textContent = CFG.addLabel;
          }
          showError(el, 'Impossible d’ajouter le combo pour le moment.');
        });
    };

    if (products.machine) run();
    else loadProducts().then(run).catch(function () {
      showError(el, 'Produits combo introuvables.');
    });
  }

  function skipCombo() {
    try {
      sessionStorage.setItem(STORAGE_KEY, '1');
    } catch (e) {}
    hideOffer();
    log('offre ignorée');
  }

  function bind(el) {
    if (!el || el.dataset.bound === '1') return;
    el.dataset.bound = '1';
    var addBtn = el.querySelector('.jcd-btn-add');
    var skipBtn = el.querySelector('.jcd-btn-skip');
    if (addBtn) addBtn.addEventListener('click', addCombo);
    if (skipBtn) skipBtn.addEventListener('click', skipCombo);
  }

  function refresh() {
    try {
      if (sessionStorage.getItem(STORAGE_KEY) === '1') {
        hideOffer();
        log('dismissed en session');
        return;
      }
    } catch (e) {}

    var el = ensureDom();
    if (!el) return;
    bind(el);

    fetch('/cart.js')
      .then(function (r) {
        return r.json();
      })
      .then(function (cart) {
        var eligible = cartEligible(cart);
        log('cart items=', (cart.items || []).length, 'eligible=', eligible, (cart.items || []).map(function (i) {
          return { title: i.title, variant: i.variant_title, inflatable: isInflatable(i), machine: isCottonMachine(i) };
        }));

        if (!eligible) {
          hideOffer(el);
          return;
        }

        showOffer(el);
        renderDetails(el);

        loadProducts()
          .then(function () {
            el = ensureDom();
            if (!el) return;
            renderDetails(el);
            showOffer(el);
          })
          .catch(function (err) {
            log('produits non chargés (offre quand même visible)', err);
          });
      })
      .catch(function (err) {
        log('cart.js error', err);
      });
  }

  window.JGQComboDrawer = {
    refresh: refresh,
    clearDismissed: function () {
      try {
        sessionStorage.removeItem(STORAGE_KEY);
      } catch (e) {}
      refresh();
    }
  };

  log('script chargé');

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', refresh);
  } else {
    refresh();
  }

  document.addEventListener('cart:updated', function () {
    setTimeout(refresh, 100);
  });

  function watchDrawer() {
    var drawer = document.querySelector('cart-drawer');
    if (!drawer || drawer.dataset.jgqComboWatch) return;
    drawer.dataset.jgqComboWatch = '1';

    var mo = new MutationObserver(function () {
      setTimeout(refresh, 120);
    });
    mo.observe(drawer, { attributes: true, attributeFilter: ['class'], childList: true, subtree: true });

    /* Hook renderContents */
    if (typeof drawer.renderContents === 'function' && !drawer.renderContents.__jgqPatched) {
      var original = drawer.renderContents.bind(drawer);
      drawer.renderContents = function (state) {
        var result = original(state);
        setTimeout(refresh, 150);
        return result;
      };
      drawer.renderContents.__jgqPatched = true;
    }
  }

  watchDrawer();
  document.addEventListener('DOMContentLoaded', watchDrawer);
  setTimeout(watchDrawer, 500);
  setTimeout(refresh, 800);
})();
